import { useNavigate } from "react-router-dom";
import { IoChevronDown, IoArrowBack } from "react-icons/io5";
import phoneMockup from "../../assets/ccmainpage.png";

export default function AboutUs() {
    const navigate = useNavigate();

    const openWaitlistSidebar = () => {
        window.dispatchEvent(new Event("open-waitlist-sidebar"));
    };

    return (
        <div className="relative flex h-full w-full flex-col overflow-hidden">
            {/* Back arrow — mobile only */}
            <button
                onClick={() => navigate(-1)}
                className="flex md:hidden items-center gap-1.5 px-4 pt-4"
            >
                <IoArrowBack className="text-[22px]" />
            </button>

            {/* Hero — fills remaining height */}
            <div className="flex flex-1 items-center gap-x-20 px-10 py-10 lg:px-14 h-full">
                {/* Left — text */}
                <div className="flex max-w-[420px] flex-col">
                    <h1 className="text-[38px] font-black leading-[1.15] text-black lg:text-[44px]">
                        Connecting people through Community.
                    </h1>

                    <p className="mt-5 text-[15px] leading-[1.65] text-[#444444]">
                        A new kind of social platform focused on real connections and
                        meaningful conversations. Because social media should bring
                        people closer, not pull them apart.
                    </p>

                    <button
                        onClick={openWaitlistSidebar}
                        className="mt-8 w-fit rounded-xl bg-[#BEE6FF] px-8 py-4 text-[16px] font-semibold text-black hover:bg-[#A8DAFA] transition-colors"
                    >
                        Join our waitlist
                    </button>
                </div>

                {/* Right — phone mockup */}
                <div className="hidden shrink-0 md:flex items-center justify-center">
                    <img
                        src={phoneMockup}
                        alt="Chaa Chingg app preview"
                        className="h-auto max-h-[520px] w-auto object-contain drop-shadow-xl"
                        draggable={false}
                    />
                </div>
            </div>

            {/* Bottom — "Why we exist" nav link */}
            <div className="flex items-center justify-center pb-6">
                <button
                    onClick={() => navigate("/about-us/why-we-exist")}
                    className="flex items-center gap-1.5 text-[14px] font-semibold text-[#2E9DDA] hover:underline"
                >
                    Why we exist
                    <IoChevronDown className="text-[15px]" />
                </button>
            </div>
        </div>
    );
}